import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import PageWrapper from "Pages/@PageWrapper"
import { HOME_ROUTES, SKU_DETAILS_ROUTES } from "@constants"
import { useUserApp } from "@hooks"
import { resetSkuDetails } from "./@signals"
import SkuDetailsDistribution from "./Distribution"
import SkuDetailsFilters from "./Filters"
import SkuDetailsKeywordsTable from "./Keywords"
import SkuDetailsPricingTable from "./Pricing"
import SkuDetailsPricingEvolution from "./PricingEvolution"
import SkuDetailsProductDetails from "./ProductDetails"
import SKuDetailsProductPagesKpiTable from "./ProductPageKpi"
import SkuDetailsReviewsTable from "./Reviews"
import SkuDetailsScores from "./Score"
import SkuDetailsStockOverview from "./Stock"


export default function SkuDetailsPage() {
    const { userAccess } = useUserApp()

    useEffect(() => {
        return () => resetSkuDetails()
    }, [])

    const warningMessage = {
        severity: 'warning',
        title: 'BETA VERSION',
        message: 'This dashboard is in beta version. If you find any bug, please report it to us.'
    }

    const props = {
        head: `DIP Insight | ${SKU_DETAILS_ROUTES.SKU_DETAILS_TITLE}`,
        title: SKU_DETAILS_ROUTES.SKU_DETAILS_TITLE,
        subtitle: SKU_DETAILS_ROUTES.SKU_DETAILS_SUBTITLE,
        isEmpty: false,
        filters: <SkuDetailsFilters />,
        globalMessages: [warningMessage]
    }

    return <PageWrapper {...props}>
        <Grid container spacing={3}>
            <Grid container item xs={12} spacing={3}>
                <Grid item xs={4} >
                    <SkuDetailsProductDetails />
                </Grid>

                <Grid item xs={3}>
                    <SkuDetailsScores />
                </Grid>

                <Grid item xs={5}>
                    <SkuDetailsDistribution />
                </Grid>
            </Grid>

            <Grid container item xs={12} spacing={3}>
                {userAccess.includes("pricing") && <Grid item xs={6}>
                    <SkuDetailsPricingTable />
                </Grid>}
                {userAccess.includes("pricing") && <Grid item xs={6}>
                    <SkuDetailsPricingEvolution />
                </Grid>}
            </Grid>

            {userAccess.includes("stock") && <Grid item xs={12}>
                <SkuDetailsStockOverview />
            </Grid>}
            {userAccess.includes("productPages") && <Grid item xs={12}>
                <SKuDetailsProductPagesKpiTable />
            </Grid>}

            <Grid container item xs={12} spacing={3}>
                {userAccess.includes("productPages") && <Grid item xs={6}>
                    <SkuDetailsReviewsTable />
                </Grid>}

                {userAccess.includes("shareOfSearch") &&<Grid item xs={6}>
                    <SkuDetailsKeywordsTable />
                </Grid>}
            </Grid>
        </Grid>
    </PageWrapper>
}